import "../css/detail.css";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LOAD_RESUME_REQUEST } from "../reducers/adminIndividual";
import {
  hasValue,
  isChecked,
  orDash,
  joinParts,
  timeRange,
  formatMoney,
} from "../util/display";
const ResumeDetail = ({ onSelectMenu, data }) => {
  const individualId = data.individualId;
  const { allUsers, userIndividuals } = useSelector((state) => state.adminUser);
  const { resume } = useSelector((state) => state.adminIndividual);
  const user = allUsers?.find((id) => id.id === data.individualId);
  const individual = userIndividuals?.find(
    (id) => id.IndividualId === data.individualId
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: LOAD_RESUME_REQUEST,
      data: {
        individualId,
      },
    });
  }, []);
  return (
    <div className="detail individual">
      <div className="detail_container">
        <div
          className="back_btn"
          onClick={() => {
            onSelectMenu(data.previousComponent);
          }}
        >
          돌아가기
        </div>
        <div className="user_box">
          <p>아이디 : {user?.user_member_id}</p>
          <p>이름 : {individual?.user_member_name}</p>
        </div>

        <div className="title">이력서</div>
        {resume && (
          <>
            {/* "이력서 제목"은 위쪽 "이름 :" 항목과 같은 내용이라 없앴습니다. */}
            <div className="text_box">
              <p className="text_title">전공</p>
              <p className="text_content">
                {orDash(resume.user_resume_schoolMajor)}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">재학기간</p>
              {/* 값이 없을 때 "null년 null월"이 그대로 보이던 것을 고쳤습니다. */}
              <p className="text_content">
                {joinParts([
                  [resume.user_resume_schoolPeriod1Year, "년"],
                  [resume.user_resume_schoolPeriod1Month, "월"],
                ]) === "-"
                  ? "-"
                  : `${joinParts([
                      [resume.user_resume_schoolPeriod1Year, "년"],
                      [resume.user_resume_schoolPeriod1Month, "월"],
                    ])} ~ ${joinParts([
                      [resume.user_resume_schoolPeriod2Year, "년"],
                      [resume.user_resume_schoolPeriod2Month, "월"],
                    ])}`}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">최종학력</p>
              <p className="text_content">
                {orDash(resume.user_resume_schoolFinal)}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">희망근무처</p>
              <p className="text_content">
                {orDash(resume.user_resume_hopeCompany)}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">근무지역</p>
              <p className="text_content">
                {isChecked(resume.user_resume_hopeRegion)
                  ? "지역무관"
                  : [
                      hasValue(resume.user_resume_hopeRegion1) &&
                        `1순위 : ${resume.user_resume_hopeRegion1}`,
                      hasValue(resume.user_resume_hopeRegion2) &&
                        `2순위 : ${resume.user_resume_hopeRegion2}`,
                    ]
                      .filter(Boolean)
                      .join(" ") || "-"}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">희망임금</p>
              {/* 임금주기가 없으면 "임금주기 : 0"처럼 나오던 것을 고쳤습니다. */}
              <p className="text_content">
                {[
                  isChecked(resume.user_resume_hopePayType1) &&
                    `임금주기 : ${resume.user_resume_hopePayType1}`,
                  `임금 : ${formatMoney(resume.user_resume_hopePay)}`,
                ]
                  .filter(Boolean)
                  .join(" ")}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">고용형태</p>
              {/* 선택하지 않은 항목까지 전부 표시되던 문제를 함께 바로잡았습니다. */}
              <p className="text_content">
                {[
                  [resume.user_resume_hopeWork1, "출근근무"],
                  [resume.user_resume_hopeWork2, "탄력근무"],
                  [resume.user_resume_hopeWork3, "재택근무"],
                  [resume.user_resume_hopeWork4, "모두가능"],
                ]
                  .filter(([checked]) => isChecked(checked))
                  .map(([, label]) => label)
                  .join(", ") || "-"}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">취업희망 시기</p>
              <p className="text_content">
                {joinParts([
                  [resume.user_resume_hopeStartYear, "년"],
                  [resume.user_resume_hopeStartMonth, "월"],
                  [resume.user_resume_hopeStartDay, "일"],
                ]) === "-"
                  ? "-"
                  : `${joinParts([
                      [resume.user_resume_hopeStartYear, "년"],
                      [resume.user_resume_hopeStartMonth, "월"],
                      [resume.user_resume_hopeStartDay, "일"],
                    ])} 부터`}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">근무 가능 시간</p>
              {/* 값이 없을 때 "null : null"이 그대로 보이던 것을 고쳤습니다.
                  입력이 없으면 대시 하나만 보여줍니다. */}
              <p className="text_content">
                {timeRange(
                  resume.user_resume_hopeWorkTime1Hour,
                  resume.user_resume_hopeWorkTime1Minute,
                  resume.user_resume_hopeWorkTime2Hour,
                  resume.user_resume_hopeWorkTime2Minute
                )}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ResumeDetail;
